import { create } from "zustand";

type Payment = {
  paymentId: number | null;
  setPaymentId: (paymentId: number | null) => void;
  nextPayment: string;
  setNextPayment: (nextPayment: string) => void;
  hasSubscriptions: boolean;
  setHasSubscriptions: (hasSubscriptions: boolean) => void;
};

export const usePaymentStore = create<Payment>((set) => ({
  paymentId: null,
  nextPayment: "",
  setPaymentId: (newPaymentId: number | null) => set({ paymentId: newPaymentId }),
  setNextPayment: (newNextPayment: string) => set({ nextPayment: newNextPayment }),
  hasSubscriptions: false,
  setHasSubscriptions: (newHasSubscriptions: boolean) => set({ hasSubscriptions: newHasSubscriptions })
}));
